import * as Yup from 'yup';

import { FORM_CONSTANTS, VALIDATION_CONSTANTS } from 'global/constants';

import { getPflegendeBUForBranchSelection } from 'utils/tenantUtil';

export const createInitialValues = (branchSelectionValues) => ({
  isAddressPublic: false,
  canSendMail: false,
  changes: '',
  pflegendeBU: getPflegendeBUForBranchSelection(branchSelectionValues),
});

export const createValidationSchema = () =>
  Yup.object().shape({
    changes: Yup.string()
      .trim()
      .nullable()
      .typeError('must be a string')
      .transform((value) => (value === '' ? null : value))
      .min(2, VALIDATION_CONSTANTS.TOO_SHORT)
      .max(FORM_CONSTANTS.FREETEXT_INPUT, VALIDATION_CONSTANTS.TOO_LONG),
    isAddressPublic: Yup.bool().required(),
    canSendMail: Yup.bool().required(),
    pflegendeBU: Yup.string()
      .trim()
      .nullable()
      .typeError('must be a string')
      .transform((value) => (value === '' ? null : value)),
  });
